import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import LanguageSelect from '../LanguageSelect';
import Button from '../Form/Toolbar/Button';
import { modePropType } from '../PpsiForm/constants';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAvailableLanguages,
  getCallback,
  getIsDataDirty,
  getLanguage
} from 'features/app/selectors';
import FormContext from 'components/Form/FormContext';
import { toJS } from 'utils/immutableUtils';
import { notify } from 'features/notificationSystem/actions';

const MarketSettingsToolbarContent = ({ data, onSave = () => {} }) => {
  const { setFieldValue } = useContext(FormContext);
  // const language = useSelector(getLanguage);
  const isDataDirty = useSelector(getIsDataDirty);
  const callback = useSelector(getCallback);
  const languages = toJS(useSelector(getAvailableLanguages));
  const dispatch = useDispatch();
  if (isDataDirty && callback) {
    onSave(data, callback);
    return null;
  }

  const handleVaildations = () => {
    // let errorArray = [];
    const salesPoint = data.salesPoint.map(itm => {
      languages.forEach(lang => {
        const slug = itm.info[lang].slug.trim();
        if (!slug) {
          itm.info[lang] = { ...itm.info[lang], message: 'error' };
          itm.message = 'Please add salespoint name!';
          // errorArray.push('salesPoint')
        } else {
          // errorArray = errorArray.filter(error => error !== 'salesPoint')
          delete itm.info[lang].message;
          delete itm.message;
        }
      });
      return itm;
    });
    setFieldValue('salesPoint', salesPoint);
    if (data.salesPoint.filter(a => a.message).length === 0) {
      onSave(data, callback);
    } else {
      dispatch(
        notify({
          message: 'Sales point name is missing',
          variant: 'error'
        })
      );
    }
  };
  return (
    <>
      <LanguageSelect />
      <Button
        label="marketSettings.saveButtonLabel"
        onClick={handleVaildations}
        // visible={isIfoodUpdateBtnVisible()}
        btnDisabled={!isDataDirty}
      />
    </>
  );
};

MarketSettingsToolbarContent.propTypes = {
  data: PropTypes.object,
  mode: modePropType.isRequired,
  onSave: PropTypes.func,
  onPublish: PropTypes.func,
  onUnpublish: PropTypes.func,
  onCreateDraft: PropTypes.func
};

export default MarketSettingsToolbarContent;
